// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'businessCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      // disabled: !ctx.isCreate,
    },
    {
      prop: 'businessDepartmentCode',
      name: '部门',
      type: 'select',
      disabled: ctx.query?.businessCompanyNo == '',
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    // {
    //   name: '客户名称',
    //   prop: 'customerNo',
    //   type: 'searchTableSpec',
    //   searchType: 'partner',
    //   extraData: {
    //     companyCode: ctx.query.businessCompanyNo,
    //     departmentCode: ctx.query.businessDepartmentCode,
    //     partnerTypes: 'HZHB01',
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeSupplyChainMethod,
    // },
    {
      name: '供应商名称',
      prop: 'supplierNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        companyCode: ctx.query.businessCompanyNo,
        departmentCode: ctx.query.businessDepartmentCode,
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
      },
      isMultiple: true,
      changeMethod: ctx.changeSupplyChainMethod,
    },
    // {
    //   name: '合同编号',
    //   prop: 'contractNo',
    //   type: 'searchTableSpec',
    //   searchType: 'contract',
    //   extraData: {
    //     contractCategory: 'sales',
    //     companyCode: ctx.query.businessCompanyNo,
    //     departmentCode: ctx.query.businessDepartmentCode,
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeContractMethod,
    // },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'multransportContract',
      extraData: {
        // contractStatus: 'ZT03',
        contractType: '0',
        isCS: 'S',
        businessDepartmentCode: ctx.query.businessDepartmentCode,
        platformCompanyName: ctx.businessCompanyName,
      },
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
    },
    {
      name: '费用编号',
      prop: 'expenseNoLike',
      type: 'input',
    },
    {
      name: '订单编号',
      prop: 'orderCodeLike', //不确定
      type: 'input',
    },
    {
      name: '指令单编号',
      prop: 'instructionNoLike',
      type: 'input',
    },
    {
      prop: 'productType',
      name: '产品',
      type: 'select',
      options: ctx.productList,
      changeMethod: ctx.changeProductTypeHandler,
    },
    {
      prop: 'serviceType',
      name: '服务',
      type: 'select',
      options: ctx.serviceList,
      changeMethod: ctx.changeServiceTypeHandler,
    },

    {
      prop: 'expenseTypeList',
      name: '费用类型',
      type: 'selectMultiple',
      // isMultiple: true,
      options: ctx.expenseTypeList,
    },
    {
      name: '费用生成日期从',
      prop: 'expenseGenerationDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '费用生成日期至',
      prop: 'expenseGenerationDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '指令下发日期从',
      prop: 'instructionIssueDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '指令下发日期至',
      prop: 'instructionIssueDateEnd',
      type: 'endDaterangePicker',
    },
    // {
    //   name: '费用异常',
    //   prop: 'abnormalExpenseFlag',
    //   type: 'select',
    //   options: [
    //     {
    //       label: '全部',
    //       value: '',
    //     },
    //     {
    //       label: '否',
    //       value: '0',
    //     },
    //     {
    //       label: '是',
    //       value: '1',
    //     },
    //   ],
    // },
    {
      name: '状态',
      prop: 'processStatus',
      type: 'select',
      options: [
        {
          label: '未处理',
          value: '0',
        },
        {
          label: '已处理',
          value: '1',
        },
      ],
    },
    {
      name: '原币结算金额(含税)',
      prop: ['originalAmountStart', 'originalAmountEnd'],
      type: 'inputRange',
      precision: 2, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
    },

    // {
    //   name: '确认状态',
    //   prop: 'confirmStatus',
    //   type: 'select',
    //   options: [
    //     {
    //       label: '全部',
    //       value: '',
    //     },
    //     {
    //       label: '待确认',
    //       value: '01',
    //     },
    //     {
    //       label: '已确认',
    //       value: '02',
    //     },
    //   ],
    // },
    // {
    //   props: 'createMethod',
    //   name: '创建方式',
    //   type: 'select',
    //   options: ctx.dictListMap?.createMethod,
    // },
    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategoryPayable || [],
    },
    // {
    //   name: '应收账期',
    //   prop: 'accountPeriod',
    //   type: 'date',
    //   format: 'yyyy-MM',
    // },
    {
      prop: 'salesmanNo',
      name: '业务员',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changeSalesmanNoMethod,
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
    },

    // {
    //   name: '车辆号',
    //   prop: 'vehicleNoLike',
    //   type: 'input',
    // },

    // {
    //   prop: 'delivererNo',
    //   name: '投送人',
    //   type: 'searchTableSpec',
    //   searchType: 'personnel',
    //   isMultiple: true,
    //   changeMethod: ctx.changeDelivererNameMethod,
    // },

    // {
    //   name: '结算单编号',
    //   prop: 'settlementNoLike',
    //   type: 'input',
    // },
  ];
};

// 默认表头
export const defaultTableColumn = (ctx) => [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  // {
  //   type: 'seq',
  //   title: 'table.index',
  //   visible: true,
  //   width: '80',
  // },

  {
    field: 'expenseNo',
    title: '费用编号',
    visible: true,
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
    visible: true,
  },
  {
    field: 'supplierName',
    title: '供应商名称',
    visible: true,
    width: '150',
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },
  {
    field: 'projectName',
    title: '项目名称',
    visible: true,
  },
  {
    field: 'orderCode', //需要确认
    title: '订单编号',
    visible: true,
    width: '150',
  },

  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'businessCompanyName',
    title: '公司名称',
    visible: true,
  },
  {
    field: 'expenseGenerationDate',
    title: '费用生成日期',
    visible: true,
  },
  ...(ctx.userInfo.businessGroup == '城矿'
    ? [
        {
          field: 'oaUrl',
          title: '审批详情',
        },
      ]
    : []),
  {
    field: 'productTypeName',
    title: '产品',
    visible: true,
    width: '150',
  },
  {
    field: 'serviceTypeName',
    title: '服务',
    visible: true,
    width: '150',
  },
  {
    field: 'instructionNo',
    title: '指令单编号',
    visible: true,
    width: '150',
  },
  {
    field: 'instructionIssueDate',
    title: '指令下发日期',
    visible: true,
    width: '150',
  },
  {
    field: 'accountPeriod',
    title: '应付账期',
    visible: true,
    width: '150',
  },
  {
    field: 'expenseTypeName',
    title: '费用类型',
    visible: true,
  },

  {
    field: 'originalPrice',
    title: '原币结算单价(含税)',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'unitName',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
    visible: true,
  },
  // {
  //   field: 'multiBillingRuleFlag',
  //   title: '是否有多个计费规则',
  //   visible: true,
  // },
  // {
  //   field: 'exceptionCode',
  //   title: '异常编号',
  //   visible: true,
  // },
  // {
  //   field: 'confirmStatus',
  //   title: '确认状态',
  //   visible: true,
  // },
  {
    field: 'processStatus',
    title: '状态',
    visible: true,
  },
  {
    field: 'settlementNo',
    title: '对账单编号',
    visible: true,
  },

  // {
  //   field: 'abnormalExpenseFlag',
  //   title: '是否是异常费用',
  //   visible: true,
  // },

  {
    field: 'createMethod',
    title: '创建方式',
    visible: true,
  },
  {
    field: 'salesmanName',
    title: '业务员',
    visible: true,
  },
  {
    field: 'isException',
    title: '是否异常费用',
    visible: true,
  },
];
// 默认显示的按钮
export const defaultMenuBtnList = [
  // {
  //   id: 1,
  //   label: '补录费用',
  //   type: '0',
  //   attributes: {
  //     // buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'add',
  //   },
  // },
  {
    id: 2,
    label: '生成对账单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
  // {
  //   id: 3,
  //   label: '草稿确认',
  //   type: '0',
  //   attributes: {
  //     // buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'enable',
  //   },
  // },
  // {
  //   id: 4,
  //   label: '删除',
  //   type: '0',
  //   attributes: {
  //     // buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'export',
  //   },
  // },
  {
    id: 5,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },
  // {
  //   id: 5,
  //   label: '批量导入',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  // {
  //   id: 6,
  //   label: '批准',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'approval',
  //   },
  // },
  // {
  //   id: 7,
  //   label: '驳回',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
];
import BASE_API from '@/api/dataBase';
import API from '@/api/intermodality/order';
import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
export default {
  data() {
    return {
      companyList: [],
      departmentList: [],
      expenseTypeList: [],
      productList: [],
      serviceAllList: [],
      serviceList: [],
      query: {
        pageNum: 1,
        pageSize: 10,
        expenseNoLike: '',
        businessCompanyNo: '',
        businessDepartmentCode: '',
        processStatus: null,
        expenseTypeList: [],
        orderCodeLike: '',
        productType: '',
        serviceType: '',
        businessCategory: '02',
        instructionNoLike: '',
        // accountPeriod: '',
        expenseGenerationDateStart: '',
        expenseGenerationDateEnd: '',
        // abnormalExpenseFlag: '',
        // confirmStatus: '',
        supplierNo: '',
        contractNo: '',
        // createMethod: '',
        originalAmountStart: '',
        originalAmountEnd: '',
        salesmanNo: '',
      },
      businessCompanyName: '',
      businessDepartmentName: '',
    };
  },
  methods: {
    // 获取公司
    async _getCompanyApi() {
      // console.log('开始获取公司', this.userInfo);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        // console.log(data.data, '???=====》》');
        this.companyList = data.data?.personCompanyInfo;
        // console.log(this.companyList, 'companyList');
        // console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');

        if (!this.userInfo.companyCode) {
          // console.log('非userInfo');
          const companyCode = data.data.personCompanyInfo
            ? data.data.personCompanyInfo[0].companyCode
            : null;
          const companyName = data.data.personCompanyInfo
            ? data.data.personCompanyInfo[0].companyName
            : null;
          this.query = {
            ...this.query,
            businessCompanyNo: companyCode,
            businessCompanyName: companyName,
          };
        } else {
          // console.log('userInfo');
          (this.query = {
            ...this.query,
            businessCompanyNo: this.userInfo.companyCode,
            // businessCompanyName: this.userInfo.companyName,
          }),
            (this.businessCompanyName = this.userInfo.companyName);
        }
        // 供应链运输事业部不默认公司
        if (this.userInfo.companyCode == 'OAC19') {
          if (this.query.businessCompanyNo) delete this.query.businessCompanyNo;
          if (this.query.businessCompanyName) delete this.query.businessCompanyName;
        } else {
          this._getDepartmentByCompanyCodeApi(this.query.businessCompanyNo, true);
        }
        setTimeout(() => {
          this.getTableData();
        }, 10);
        // this._getDepartmentByCompanyCodeApi(this.query.businessCompanyNo, true);
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
      console.log(companyCode, isFirst);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        console.log(data.data, '部门信息');
        this.departmentList = data.data?.personDepartmentInfo;
        // if (isFirst) {
        //   this.query = {
        //     ...this.query,
        //     businessDepartmentCode: this.userInfo?.departmentCode,
        //     // businessDepartmentName: this.userInfo?.departmentName,
        //   };
        //   this.businessDepartmentName = this.userInfo?.departmentName;
        //   setTimeout(() => {
        //     this.getTableData();
        //   }, 10);
        // }
      } else {
        console.error('获取部门失败');
      }
    },
    // 切换公司
    changeCompanyHandler(val) {
      // console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      // console.log(item, '切换公司item');
      this.query = {
        ...this.query,
        businessDepartmentCode: '',
        // businessDepartmentName: '',
        businessCompanyNo: val,
        // businessCompanyName: item.personCompanyName,
      };
      this.businessCompanyName = item.personCompanyName;
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      // console.log(val, '切换部门');
      // console.log(this.departmentList, 'this.departmentList');

      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.query = {
        ...this.query,
        businessDepartmentCode: val,
        // businessDepartmentName: item.personDepartmentName,
      };
      this.businessDepartmentName = item.personDepartmentName;
    },
    // 切换产品
    changeProductTypeHandler(val) {
      this.query.serviceType = '';
      this.query.expenseTypeList = [];
      this.expenseTypeList = [];
      this.serviceList = [];
      if (val == '0') {
        this.serviceList = this.serviceAllList.slice(0, 6);
      } else if (val == '1') {
        this.serviceList = this.serviceAllList.slice(6);
      }
    },
    // 切换服务
    async changeServiceTypeHandler(val) {
      console.log(val, '服务');
      this.query.expenseTypeList = [];
      this.expenseTypeList = [];
      if (!val) {
        return;
      }
      let postData = {
        serviceNo: val,
      };
      const { data } = await this.$axios.post(
        RECEIVABLES_MULTIMODALTRANSPORT.SERVICE_EXPENSELIST_API,
        postData
      );
      if (data.code == 0) {
        this.expenseTypeList = [];
        if (data.data.length) {
          data.data.map((item) => {
            this.expenseTypeList.push({
              label: item.expenseName,
              value: item.expenseNo,
            });
          });
        }
      }
      console.log(data, '根据服务类型获取费用类型');
    },

    // 产品列表
    getProductList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-PRODUCT-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.productList = res.data.data || [];
            console.log(res.data.data, '产品');
          }
        });
    },
    // 服务列表
    getServiceList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-SERVICE-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.serviceAllList = res.data.data || [];
            console.log(res.data.data, '服务');
          }
        });
    },
  },

  mounted() {
    // this.getCompanyApi();
    this.$nextTick(() => {
      this._getCompanyApi();
      this.getProductList();
      this.getServiceList();
    });
    // this.expenseTypeList = this.dictListMap?.expenseType.filter(
    //   (item) => item.remark == '多式联运'
    // );
  },
};
